export { default as azureTeamSyncRepository } from './azureTeamSyncRepository';
export type { AzureTeamSyncData, AzureTeamSyncMember } from './azureTeamSyncRepository';

// Central initialization function for all repositories
export const initializeRepositories = async (): Promise<void> => {
  try {
    // Initialize all repositories here
    // Currently we only have azureTeamSyncRepository, which auto-initializes on first use
    
    // Clean up expired entries on startup
    const { azureTeamSyncRepository } = await import('./azureTeamSyncRepository');
    await azureTeamSyncRepository.cleanupExpiredEntries();
    
    console.log('Repositories initialized successfully');
  } catch (error) {
    console.error('Error initializing repositories:', error);
    // Don't throw error as app should continue to work even if IndexedDB fails
  }
};

// Utility function to clear all cached data (useful for logout or reset)
export const clearAllRepositoryData = async (): Promise<void> => {
  try {
    const { azureTeamSyncRepository } = await import('./azureTeamSyncRepository');
    await azureTeamSyncRepository.clearAllCachedData();
    
    console.log('All repository data cleared successfully');
  } catch (error) {
    console.error('Error clearing repository data:', error);
  }
}; 